<template>
    <div>
        <!-- <headLine></headLine> -->
        <div class="elder_manage_title">
            <p class="title">沟通类型</p>
        </div>
        <slot name="statistics"></slot>
        <div class="search_wrapper">
            <div class="search_head">
                <span>查询条件</span>
                <el-button
                    style="float: right; padding: 3px 0; color: #000"
                    type="text"
                    @click="Reset"
                >
                    <i class="el-icon-refresh"></i>
                    刷新页面
                </el-button>
            </div>
            <div class="search_content">
                <div class="search_inline" v-show="isSearchContent">
                    <el-form label-width="120px">
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="类型名称：">
                                    <el-input
                                        clearable
                                        placeholder="请输入"
                                        v-model="searchObj.name"
                                        size="primary"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="3" :offset="2">
                                <el-button
                                    type="primary"
                                    size="medium"
                                    @click="query"
                                    >查询</el-button
                                >
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <div class="arrowDown">
                    <i
                        :class="
                            isSearchContent === true
                                ? 'el-icon-arrow-up'
                                : 'el-icon-arrow-down'
                        "
                        style="color: #000"
                        @click="isSearchContent = !isSearchContent"
                    ></i>
                </div>
            </div>
        </div>

        <el-button
            icon="el-icon-plus"
            style="margin: 10px 0"
            type="success"
            size="medium"
            @click="showDialog('新增')"
        >
            新增
        </el-button>

        <el-table
            :data="tableData"
            border
            style="width: 100%; margin-bottom: 15px"
            ref="addForm"
            :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
        >
            <el-table-column
                type="index"
                width="70"
                label="序号"
                align="center"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
                prop="name"
                label="类型名称"
                align="center"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
                prop="status"
                label="状态"
                align="center"
                :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    <el-switch
                        active-value="1"
                        inactive-value="0"
                        @change="onStatusChange(scope.row)"
                        v-model="scope.row.status"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                    >
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="150">
                <template slot-scope="scope">
                    <el-button
                        @click="showDialog('查看', scope.row)"
                        type="text"
                        >查看</el-button
                    >
                    <el-button
                        @click="showDialog('编辑', scope.row)"
                        type="text"
                        >编辑</el-button
                    >
                    <el-button @click="deleteItem(scope.row.id)" type="text"
                        >删除</el-button
                    >
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageConfig.pageNo"
            :page-sizes="[5, 10, 20, 50]"
            :page-size="pageConfig.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageConfig.total"
        >
        </el-pagination>

        <!-- 表单弹框-->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="500px"
            :close-on-click-modal="false"
            :before-close="handleClose"
        >
            <el-form
                :disabled="dialogTitle === '查看'"
                :model="addForm"
                :rules="rules"
                ref="addForm"
                label-width="80px"
            >
                <el-form-item label="类型名称:" prop="name">
                    <el-input
                        v-model="addForm.name"
                        placeholder="请输入"
                    ></el-input>
                </el-form-item>

                <el-form-item label="状态:" prop="status">
                    <el-radio-group v-model="addForm.status">
                        <el-radio label="1">启用</el-radio>
                        <el-radio label="0">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div
                v-if="dialogTitle !== '查看'"
                style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 15px;
                "
            >
                <el-button @click="send" type="primary">确定</el-button>
                <el-button @click="handleClose" type="info">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import globalTag from "../components/globalTag"
import headLine from "../components/headline"
import baseURL from "@/api/baseURL"

export default {
    components: {
        globalTag,
        headLine,
    },
    data() {
        return {
            searchObj: {
                serviceTypeId: "",
                name: "",
            },
            dialogTitle: "",
            dialogVisible: false,
            editId: "",
            addForm: {
                name: "",
                status: "1",
            },
            rules: {
                item: [
                    {
                        required: true,
                        message: "请输入服务项目",
                        trigger: "blur",
                    },
                ],
                status: [
                    { required: true, message: "请选择状态", trigger: "blur" },
                ],
            },
            tableData: [],
            // 分页
            pageConfig: {
                pageNo: 1,
                pageSize: 10,
                total: 0,
            },
            isSearchContent: true,
        }
    },
    created() {
        this.getTableData()
    },
    methods: {
        // 搜索
        query() {
            this.pageConfig.pageNo = 1
            this.getTableData()
        },
        Reset() {
            this.searchObj = {}
            this.getTableData()
        },
        // 数据状态发生改变
        onStatusChange(row) {
            this.$http
                .request({
                    url: "/jjyl/admin/communicationType/info/insert",
                    method: "POST",
                    data: {
                        status: row.status,
                        id: row.id,
                        name: row.name,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        this.$message.success(res.message)
                    } else {
                        this.$message.error(res.message)
                    }
                    this.getTableData()
                })
        },
        // 提交
        send() {
            this.$refs.addForm.validate((valid) => {
                // 校验通过
                if (valid) {
                    let data = {
                        ...this.addForm,
                    }
                    this.$http
                        .request({
                            url: "/jjyl/admin/communicationType/info/insert",
                            method: "POST",
                            data: data,
                        })
                        .then((res) => {
                            if (res.code == 200) {
                                this.$message.success("操作成功")
                                this.handleClose()
                                this.getTableData()
                            }
                        })
                }
            })
        },
        // 删除某一项
        deleteItem(id) {
            this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$http
                    .request({
                        url: "/jjyl/admin/communicationType/info/deleteById",
                        method: "POST",
                        data: {
                            id,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            this.$message.success("删除成功")
                            this.getTableData()
                        }
                    })
            })
        },
        // 显示弹框
        showDialog(title, row) {
            this.dialogTitle = title
            this.dialogVisible = true

            if (title != "新增") {
                this.addForm = {
                    name: row.name,
                    status: row.status,
                    id: row.id,
                }
            } else {
                this.addForm = {
                    name: "",
                    status: "1",
                }
            }
        },
        // 关闭弹框
        handleClose() {
            this.dialogVisible = false
            this.$refs.addForm.resetFields()
        },

        // 获取列表数据
        getTableData() {
            this.$http
                .request({
                    url: "/jjyl/admin/communicationType/info/findList",
                    method: "POST",
                    data: {
                        pageNo: this.pageConfig.pageNo,
                        pageSize: this.pageConfig.pageSize,
                        name: this.searchObj.name,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (!res.content) {
                            this.tableData = []
                            this.pageConfig.total = 0
                        } else {
                            this.tableData = res.content.list || []
                            this.pageConfig.total = res.content.count || 0
                        }
                    }
                })
        },
        // 每页显示条数切换
        handleSizeChange(val) {
            this.pageConfig.pageSize = val
            this.getTableData()
        },
        // 页码切换
        handleCurrentChange(val) {
            this.pageConfig.pageNo = val
            this.getTableData()
        },
    },
}
</script>

<style lang="less" scoped>
/deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    width: 100px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
    }

    .avatar {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;

        img {
            width: 100px;
            height: 100px;
            line-height: 100px;
            display: block;
        }
    }
}
.elder_manage_title {
    position: relative;
    width: 100%;
    margin-bottom: 15px;
    &::after {
        position: absolute;
        left: 120px;
        right: 0;
        display: block;
        content: "";
        border-bottom: 1px solid #e4e7ed;
    }
    .title {
        box-sizing: border-box;
        display: inline-block;
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #409eff;
        font-size: 14px;
        border: 1px solid #e4e7ed;
        border-bottom: none;
        border-radius: 4px 4px 0 0;
        box-sizing: border-box;
        background: #ffffff;
    }
}
/deep/ .search_wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #F1F2F6;
  box-shadow:  0 0 6px rgba(151, 151, 151, .16);
  overflow: hidden;
  border-radius: 4px;
  .search_head {
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: rgb(0, 0, 0);
    border-color: rgb(217, 217, 217);
    padding: 6px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
  .search_content {
    padding: 15px 20px 0px 5px;
    border: 1px solid rgb(217, 217, 217);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .search_inline {
    width: 100%;
  }
  .arrowDown {
    width: 28px;
    height: 28px;
    background: #edf2f0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0px);
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
  }
}
.searchDomw{cursor: pointer;}
</style>
